module.exports = __webpack_public_path__ + "img/sent-message-icon.7afa88de.svg";